<template>
  <offer-detail-table
    v-for="dominio of Object.keys(groupedProdotti).toSorted(groupOrder)"
    :key="dominio"
    :products="$as<(typeof groupedProdotti)[string]>(groupedProdotti[dominio])"
    :domain="dominio"
    :currency="offerta.currency"
    :no-card="noCard"
    @remove-products="onRemoveProducts"
  />

  <template v-if="!hideTotals">
    <pf-title class="pf-v6-u-mt-xl" h="4">{{ $t("Note") }}</pf-title>
    <p data-ouia-component-id="note_offerta" class="text-preline">{{ offerta.note_offerta }}</p>

    <pf-title class="pf-v6-u-mt-xl" h="4">{{ $t("Riepilogo") }}</pf-title>
    <pf-description-list
      horizontal
      class="payment-totals"
      term-width="30ch"
      style="max-width: 80ch"
    >
      <offer-total
        :label="$t('Totale attuale a te riservato')"
        :totali="offerta.totali_disdetti"
        durata="Annuale"
        :currency="offerta.currency"
      />
      <offer-total
        :label="$t('Totale attuale a te riservato')"
        :totali="offerta.totali_disdetti"
        durata="Mensile"
        :currency="offerta.currency"
      />
      <offer-total
        :label="$t('Totale attuale a te riservato')"
        :totali="offerta.totali_disdetti"
        durata="Una tantum"
        :currency="offerta.currency"
      />

      <offer-total :totali="offerta.totali" big durata="Annuale" :currency="offerta.currency" />
      <offer-total :totali="offerta.totali" big durata="Mensile" :currency="offerta.currency" />
      <offer-total :totali="offerta.totali" big durata="Una tantum" :currency="offerta.currency" />
    </pf-description-list>

    <pf-description-list
      v-if="!hideTotals"
      horizontal
      class="payment-totals pf-v6-u-mt-xl"
      term-width="30ch"
      style="max-width: 80ch"
    >
      <pf-description-list-group v-if="Number(offerta.sconto_custom) > 0">
        <pf-description-list-term>{{ $t("Sconto in fattura") }}</pf-description-list-term>
        <pf-description-list-description class="pf-v6-u-text-align-end">
          {{ $currency(-offerta.sconto_custom, offerta.currency) }}
          <span class="vat">({{ $t("IVA esclusa") }})</span>
        </pf-description-list-description>
      </pf-description-list-group>

      <pf-description-list-group v-if="Number(offerta.valore_storno) > 0">
        <pf-description-list-term>{{
          $t("Sconto per periodo non usufruito")
        }}</pf-description-list-term>
        <pf-description-list-description class="pf-v6-u-text-align-end">
          {{ $currency(-offerta.valore_storno, offerta.currency) }}
          <span class="vat">({{ $t("IVA esclusa") }})</span>
        </pf-description-list-description>
      </pf-description-list-group>

      <pf-description-list-group>
        <pf-description-list-term>{{ $t("Totale offerta") }}</pf-description-list-term>
        <pf-description-list-description class="pf-v6-u-text-align-end">
          {{ $currency(offerta.gran_totale, offerta.currency) }}
          <span class="vat">({{ $t("IVA esclusa") }})</span>
        </pf-description-list-description>
      </pf-description-list-group>

      <pf-description-list-group>
        <pf-description-list-term>{{ $t("Totale con IVA") }}</pf-description-list-term>
        <pf-description-list-description class="pf-v6-u-text-align-end">
          {{ $currency(offerta.gran_totale_ivato, offerta.currency) }}
          <span class="vat">({{ $t("IVA inclusa") }})</span>
        </pf-description-list-description>
      </pf-description-list-group>
    </pf-description-list>
  </template>
</template>

<style scoped>
.striked {
  text-decoration: line-through;
}
.text-preline {
  white-space: pre-line;
}
</style>

<script lang="ts" setup>
import type { Offer, OfferProductDetail } from "@/resources";
import { computed } from "vue";
import OfferTotal from "./offer-total.vue";
import OfferDetailTable from "./offer-detail-table.vue";

const props = defineProps<{
  offerta: Offer;
  hideTotals?: boolean;
  noCard?: boolean;
  onRemoveProducts?: (domain: string) => void;
}>();

const groupedProdotti = computed(() => {
  const prodotti: Record<string, OfferProductDetail[]> = {};

  for (const prodotto of props.offerta.prodotti_disdire) {
    const dom = prodotto.dominio ?? "";
    (prodotti[dom] = prodotti[dom] || []).push({ ...prodotto, disdire: true });
  }

  for (const prodotto of props.offerta.prodotti) {
    const dom = prodotto.dominio ?? "";
    if (prodotto.migratedFrom) {
      const oldDom = prodotto.migratedFrom.dominio ?? "";
      (prodotti[oldDom] = prodotti[oldDom] || []).push({ ...prodotto.migratedFrom, disdire: true });
    }
    (prodotti[dom] = prodotti[dom] || []).push({ ...prodotto, disdire: false });
  }

  return prodotti;
});

function groupOrder(a: string, b: string) {
  if (a === "") {
    return 1;
  }
  if (b === "") {
    return -1;
  }
  return a.localeCompare(b);
}
</script>
